// Disponibilidad por producto/talla en la tienda pública.
//
// CONVENCIÓN CRÍTICA (regresión 2026-09-23): `available === null` significa
// **SIN RASTREO = ILIMITADO**, NO "cero". El bug que sacó "Agotado" a un tenant
// real nació de `Number(null) === 0` en el backend y de comparaciones `<= 0` en
// el front que tratan `null` como `0` (en JS `null <= 0` es `true`).
//
// Para que el tipo IMPIDA el error (y no dependa de acordarse): el valor es
// `Availability = number | null` y NADIE compara crudo — todo pasa por estos
// helpers puros. Si ves `v.available <= 0` suelto en la tienda, es un bug.
export type Availability = number | null;

// Tope de unidades cuando no se rastrea (ilimitado en la práctica para la UI).
export const UNLIMITED_CAP = 99;

/** null = sin rastreo (ilimitado). */
export const isUnlimited = (a: Availability): boolean => a == null;

/** Agotado SÓLO si se rastrea (número) y no queda nada. null nunca está agotado. */
export const isSoldOut = (a: Availability): boolean => a != null && a <= 0;

/** Tope de unidades comprables de una talla. null (ilimitado) => UNLIMITED_CAP. */
export const unitCap = (a: Availability): number => (a == null ? UNLIMITED_CAP : Math.max(0, a));

/** Etiqueta corta por talla: "Agotada" | "Solo N" | "Disponible". null => "Disponible". */
export const stockLabel = (a: Availability): string =>
  a == null ? 'Disponible' : a <= 0 ? 'Agotada' : a <= 3 ? `Solo ${a}` : 'Disponible';
